import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import exampleLogo from "./../ExampleLogo.png";
import { Modal, Button } from "react-bootstrap";
import Cookies from "js-cookie";

/*
  Filename:    CreateOrganization.js
  Description: This component is used by the Bridging Hope Admin to create a new organization.
*/

// data sent to the post.api/organization endpoint should be sent in the following format:

function CreateOrganization() {
  //const url = 'https://bridginghope.life/api/foodPantry/organization';
  const url = process.env.REACT_APP_BACKURL + "/api/foodPantry/organization"; //uncomment for local testing
  const navigate = useNavigate();

  const [organizationInfo, setOrganizationInfo] = useState({
    orgID: "",
    name: "",
    description: "",
    logo: "",
    orgType: "",
  });

  const [phoneInfo, setPhoneInfo] = useState({
    phoneID: "",
    countryCode: "",
    areaCode: "",
    telPrefix: "",
    lineNum: "",
    isActive: true,
    isSafe: true,
    phoneType: "",
  });

  const [addressInfo, setAddressInfo] = useState({
    addressID: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    addressType: "",
  });

  const [userInfo, setUserInfo] = useState({
    userID: "",
    email: "",
    userName: "",
    password: "",
  });

  const [confirmPassword, setConfirmPassword] = useState({
    confirmPassword: "",
  });

  const services = [
    { serviceID: 0, serviceType: "Food Pantry" },
    { serviceID: 1, serviceType: "Financial Assistance" },
    { serviceID: 2, serviceType: "Medical Services" },
    { serviceID: 3, serviceType: "Transportation Services" },
    { serviceID: 4, serviceType: "Laundry Services" },
  ];

  // const [serviceInfo, setServiceInfo] = useState([]);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (event) => {
    const { dataset, name, value, checked } = event.target;

    if (dataset.type === "organization") {
      setOrganizationInfo({
        ...organizationInfo,
        [name]: value,
      });
    }
    if (dataset.type === "phone") {
      if (name === "phoneNumber") {
        let countryCode = phoneInfo.countryCode || "1";
        let areaCode = value.slice(0, 3);
        let telPrefix = value.slice(3, 6);
        let lineNum = value.slice(6, 10);
        setPhoneInfo({
          ...phoneInfo,
          countryCode: countryCode,
          areaCode: areaCode,
          telPrefix: telPrefix,
          lineNum: lineNum,
        });
      } else {
        setPhoneInfo({
          ...phoneInfo,
          [name]: value,
        });
      }
    }
    if (dataset.type === "address") {
      setAddressInfo({
        ...addressInfo,
        [name]: value,
      });
    }
    if (dataset.type === "user") {
      setUserInfo({
        ...userInfo,
        [name]: value,
      });
    }
    if (dataset.type === "confirmPassword") {
      setConfirmPassword({
        ...confirmPassword,
        [name]: value,
      });
    }
    // if (dataset.type === "service") {
    //   setServiceInfo((prev) => {
    //     if (checked) {
    //       // Add the service if checked
    //       return [...prev, { serviceID: dataset.serviceid, [name]: value }];
    //     } else {
    //       // Remove the service if unchecked
    //       return prev.filter((s) => s.serviceID !== dataset.serviceid);
    //     }
    //   });
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let params = {
      organization: organizationInfo,
      phone: phoneInfo,
      address: addressInfo,
      user: userInfo,
      // services: serviceInfo,
    };

    //Make the API call
    try {
      //Get the cookie
      const sessionID = Cookies.get("sessionID");

      if (!sessionID) {
        alert("Session expired. Please log in again.");
        navigate("/SignIn");
        return;
      }

      const response = await axios.post(url, params, {
        withCredentials: true, //Ensures cookies are sent
      });
      console.log("Organization created: ", response);

      setShowSuccessModal(true); // Show success modal
    } catch (error) {
      console.error("Error creating organization: ", error);

      //If the response exists
      if (error.response) {
        console.error("Response status: ", error.response.status);
        console.error("Response data: ", error.response.data);
        const errorMessage = error.response?.data?.message; // || 'Error creating organization';
        alert(`Registration Failed: ` + errorMessage);

        //Database Error
      } else if (error.request) {
        console.error("Request error: ", error.request);
        alert("No response from server");

        //Other errors
      } else {
        console.error("Unexpected Error:" + error.message);
        alert("Unexpected Error: " + error.message);
      }
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    navigate("/dashboard"); // Redirect to dashboard
  };

  return (
    <React.Fragment>
      <div className="card col-12 col-md-10 offset-0 offset-md-1 mt-5 card-body container my-3">
        <div className="card-header justify-content-between align-items-center pb-3">
          <h3>
            <span>
              <i className="bi bi-building-add pe-3"></i>
              Create Organization
            </span>
          </h3>

          <form onSubmit={handleSubmit} className="mt-5">
            <div className="card border border-light m-2">
              <div className="card-header border-bottom border-light">
                <h3 className="text-center mb-1">Organization Information</h3>
              </div>
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="txtOrgName"
                        type="text"
                        placeholder="Organization XYZ"
                        aria-label="Enter the Organization name"
                        className="form-control"
                        data-type="organization"
                        name="name"
                        value={organizationInfo.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="orgName" className="form-label">
                        Organization name
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <select
                        id="txtOrgType"
                        className="form-select form-select-floating-fix pb-0 pt-3 ps-3"
                        data-type="organization"
                        aria-label="Select the Organization type"
                        name="orgType"
                        value={organizationInfo.orgType}
                        onChange={handleChange}
                      >
                        <option
                          value="default"
                          className="text-secondary"
                          aria-label="select ID Type"
                        >
                          select
                        </option>
                        <option value="Religious">
                          Religious Organization
                        </option>
                        <option value="Government">Government</option>
                        <option value="Nonprofit">Nonprofit</option>
                      </select>
                      <label htmlFor="orgType" className="form-label">
                        Organization type
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        id="orgLogo"
                        className="form-control"
                        type="file"
                        data-type="organization"
                        aria-label="Upload a photo of your organization logo"
                        name="logo"
                        value={organizationInfo.logo}
                        onChange={handleChange}
                      />
                      <label htmlFor="orgLogo" className="form-label">
                        Upload logo
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        id="orgDescription"
                        className="form-control"
                        placeholder="Description of the organization"
                        aria-label="Enter the Organization description"
                        rows="3"
                        data-type="organization"
                        name="description"
                        value={organizationInfo.description}
                        onChange={handleChange}
                      ></textarea>
                      <label htmlFor="orgDescription" className="form-label">
                        Description
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card border border-light m-2">
              <div className="card-header border-bottom border-light">
                <h3 className="text-center mb-1">Contact Information</h3>
              </div>
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-12 col-lg-8">
                    <div className="input-group">
                      <div className="col-12 col-lg-3 input-group-text">
                        <select
                          id="countryCode"
                          className="form-select form-select-floating-fix pb-0 pt-3 ps-3"
                          placeholder="+1"
                          aria-label="Select the country code of your organization phone number"
                          data-type="phone"
                          name="countryCode"
                          value={phoneInfo.countryCode}
                          onChange={handleChange}
                        >
                          <option value="1">+1</option>
                        </select>
                      </div>
                      <div className="form-floating">
                        <input
                          id="phone"
                          type="tel"
                          placeholder="1234567890"
                          className="form-control"
                          data-type="phone"
                          aria-label="Enter the Organization phone number"
                          name="phoneNumber"
                          value={
                            phoneInfo.areaCode +
                            phoneInfo.telPrefix +
                            phoneInfo.lineNum
                          }
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="phone" className="form-label">
                          Phone Number
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="form-floating">
                      <select
                        id="phoneType"
                        className="form-select form-select-floating-fix pb-0 pt-3 ps-3"
                        aria-label="Select the phone type"
                        data-type="phone"
                        name="phoneType"
                        value={phoneInfo.phoneType}
                        onChange={handleChange}
                      >
                        <option value="default">--select--</option>
                        <option value="Personal">Personal</option>
                        <option value="Work">Work</option>
                        <option value="Business">Business</option>
                      </select>
                      <label htmlFor="phoneType" className="form-label">
                        Phone type
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card border border-light m-2">
              <div className="card-header border-bottom border-light">
                <h3 className="text-center mb-1">Address Information</h3>
              </div>
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="addressLine1"
                        type="text"
                        placeholder="123 Cherry Lane"
                        className="form-control"
                        data-type="address"
                        aria-label="Enter the address line 1"
                        name="addressLine1"
                        value={addressInfo.addressLine1}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="addressLine1" className="form-label">
                        Address Line 1
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="addressLine2"
                        type="text"
                        placeholder="Apartment 001"
                        className="form-control"
                        data-type="address"
                        aria-label="Enter address line 2"
                        name="addressLine2"
                        value={addressInfo.addressLine2}
                        onChange={handleChange}
                      />
                      <label htmlFor="addressLine2" className="form-label">
                        Address Line 2 (Optional)
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="form-floating">
                      <input
                        id="city"
                        type="text"
                        placeholder="City"
                        className="form-control"
                        data-type="address"
                        aria-label="Enter the city"
                        name="city"
                        value={addressInfo.city}
                        onChange={handleChange}
                      />
                      <label htmlFor="city" className="form-label">
                        City
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="form-floating">
                      <select
                        id="state"
                        className="form-select form-select-floating-fix pb-0 pt-3 ps-3"
                        aria-label="Select the state"
                        data-type="address"
                        name="state"
                        value={addressInfo.state}
                        onChange={handleChange}
                      >
                        <option value="default">--select--</option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                      <label htmlFor="state" className="form-label">
                        State
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="form-floating">
                      <input
                        id="zip"
                        type="text"
                        placeholder="Zip"
                        className="form-control"
                        data-type="address"
                        aria-label="Enter the zip code"
                        name="zip"
                        value={addressInfo.zip}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="zip" className="form-label">
                        Zip
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <select
                        id="addressType"
                        className="form-select form-select-floating-fix pb-0 pt-3 ps-3"
                        aria-label="Select the address type"
                        data-type="address"
                        name="addressType"
                        value={addressInfo.addressType}
                        onChange={handleChange}
                      >
                        <option value="default">--select--</option>
                        <option value="Home">Home</option>
                        <option value="Shelter">Shelter</option>
                        <option value="Business">Business</option>
                      </select>
                      <label htmlFor="addressType" className="form-label">
                        Address type
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*<h2 className="fs-4 mt-4 mb-2">Services</h2>*/}
            {/* {services.map((service) => (
              <div className="form-check" key={service.serviceID}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={"txt" + service.serviceType.replaceAll(" ", "")}
                  data-type="service"
                  name="serviceType"
                  value={service.serviceType}
                  data-serviceid={service.serviceID}
                  checked={serviceInfo.some(
                    (s) => Number(s.serviceID) === Number(service.serviceID)
                  )}
                  onChange={handleChange}
                />
                <label
                  htmlFor={"txt" + service.serviceType.replaceAll(" ", "")}
                  className="form-check-label"
                >
                  {service.serviceType}
                </label>
              </div>
            ))} */}

            <div className="card border border-light m-2">
              <div className="card-header border-bottom border-light">
                <h3 className="text-center mb-1">User Information</h3>
              </div>
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="userEmail"
                        type="email"
                        placeholder="Email"
                        className="form-control"
                        aria-label="Enter the Organization email"
                        data-type="user"
                        name="email"
                        value={userInfo.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="userName"
                        type="text"
                        placeholder="Username"
                        className="form-control"
                        data-type="user"
                        aria-label="Enter the Organization username"
                        name="userName"
                        value={userInfo.userName}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="userName" className="form-label">
                        Username
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="password"
                        type="password"
                        placeholder="Password"
                        className="form-control"
                        data-type="user"
                        aria-label="Enter the Organization password"
                        name="password"
                        value={userInfo.password}
                        onChange={handleChange}
                      />
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="txtConfirmPassword"
                        type="password"
                        placeholder="Password"
                        className="form-control"
                        data-type="confirmPassword"
                        aria-label="Enter the Organization password again to confirm it"
                        name="confirmPassword"
                        value={confirmPassword.confirmPassword}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="txtConfirmPassword"
                        className="form-label"
                      >
                        Confirm Password
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <button type="submit" className="btn btn-primary">
                Create Organization!
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title>Organization Created!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Your organization has been successfully created!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="btn-primary"
            onClick={() => setShowSuccessModal(false)}
          >
            Close
          </Button>        
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default CreateOrganization;
